import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

export const get_series_for_release_management_by_content_house =
  createAsyncThunk<any, any, any>(
    'auto/get/series/for/release/managent/by/content/house',
    async (params, apiThunk: { getState: any }) => {
      let { getState } = apiThunk
      let state = getState()
      let bearToken = getBearerToken(state)
      if (bearToken) {
        try {
          let response = await fetch(
            ResolveUrl('auto/get/series/for/release/managent/by/content/house'),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${bearToken}`,
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify(params),
            },
          )
          let res = await response.json()
          if (params && params.callback) {
            params.callback(true, res)
          }

          return res
        } catch (e) {
          if (params && params.callback) {
            params.callback(false, e)
          }
        }
      } else {
        if (params && params.callback) {
          params.callback(false)
        }
        throw 'not signed in'
      }
    },
  )

export const get_contenthouse_for_release_management_by_content_house =
  createAsyncThunk<any, any, any>(
    'auto/get/contenthouse/for/release/managent/by/content/house',
    async (params, apiThunk: { getState: any }) => {
      let { getState } = apiThunk
      let state = getState()
      let bearToken = getBearerToken(state)
      if (bearToken) {
        try {
          let response = await fetch(
            ResolveUrl(
              'auto/get/contenthouse/for/release/managent/by/content/house',
            ),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${bearToken}`,
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify(params),
            },
          )
          let res = await response.json()
          if (params && params.callback) {
            params.callback(true, res)
          }

          return res
        } catch (e) {
          if (params && params.callback) {
            params.callback(false, e)
          }
        }
      } else {
        if (params && params.callback) {
          params.callback(false)
        }
        throw 'not signed in'
      }
    },
  )

export const get_content_house_media_snapshot_for_release_management_by_content_house =
  createAsyncThunk<any, any, any>(
    'auto/get/mediasnapshot/for/release/managent/by/content/house',
    async (params, apiThunk: { getState: any }) => {
      let { getState } = apiThunk
      let state = getState()
      let bearToken = getBearerToken(state)
      if (bearToken) {
        try {
          let response = await fetch(
            ResolveUrl(
              'auto/get/mediasnapshot/for/release/managent/by/content/house',
            ),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${bearToken}`,
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify(params),
            },
          )
          let res = await response.json()
          if (params && params.callback) {
            params.callback(true, res)
          }

          return res
        } catch (e) {
          if (params && params.callback) {
            params.callback(false, e)
          }
        }
      } else {
        if (params && params.callback) {
          params.callback(false)
        }
        throw 'not signed in'
      }
    },
  )

export const get_contet_houses_for_release_management = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/get/content/houses/for/release/managent',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/content/houses/for/release/managent'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_releasescheduleactions_for_release_management_by_content_house =
  createAsyncThunk<any, any, any>(
    'auto/get/release/schedule/acttions/for/release/managent/by/content/house',
    async (params, apiThunk: { getState: any }) => {
      let { getState } = apiThunk
      let state = getState()
      let bearToken = getBearerToken(state)
      if (bearToken) {
        try {
          let response = await fetch(
            ResolveUrl(
              'auto/get/release/schedule/acttions/for/release/managent/by/content/house',
            ),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${bearToken}`,
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify(params),
            },
          )
          let res = await response.json()
          if (params && params.callback) {
            params.callback(true, res)
          }

          return res
        } catch (e) {
          if (params && params.callback) {
            params.callback(false, e)
          }
        }
      } else {
        if (params && params.callback) {
          params.callback(false)
        }
        throw 'not signed in'
      }
    },
  )

export const update_release_schedule_action_for_release_management =
  createAsyncThunk<any, any, any>(
    'auto/update/release/schedule/action/for/release/managent',
    async (params, apiThunk: { getState: any }) => {
      let { getState } = apiThunk
      let state = getState()
      let bearToken = getBearerToken(state)
      if (bearToken) {
        try {
          let response = await fetch(
            ResolveUrl(
              'auto/update/release/schedule/action/for/release/managent',
            ),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${bearToken}`,
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify(params),
            },
          )
          let res = await response.json()
          if (params && params.callback) {
            params.callback(true, res)
          }

          return res
        } catch (e) {
          if (params && params.callback) {
            params.callback(false, e)
          }
        }
      } else {
        if (params && params.callback) {
          params.callback(false)
        }
        throw 'not signed in'
      }
    },
  )
